'use strict';
var config = require('../config.js');

var offerLetterListCtrl = function ($scope, Jobs, railApi, $translate, $stateParams, $rootScope) {

};

module.exports = offerLetterListCtrl;